import storage from 'store'
/**
 * 设置wx title
 * @param {*} title 
 */
export const setTitle = (title) => {
  document.title = title;
  var i = document.createElement('iframe');
  i.src = '//m.baidu.com/favicon.ico';
  i.style.display = 'none';
  i.onload = function() {
    setTimeout(function(){
      i.remove();
    }, 9)
  }
  document.body.appendChild(i);
}
/**
 * 时间转换
 * @param {} d
 */
 export function formatDate (d, hasYmd) {
  var date = new Date(d * 1000)
  var YY = date.getFullYear() + '-'
  var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
  var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
  var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
  var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
  if (hasYmd) {
    return YY + MM + DD
  } else {
    return YY + MM + DD + ' ' + hh + mm + ss
  }
}
/**
 * 时间转换
 * @param {} d
 */
 export function formatTime (d, hasYmd) {
  let date = new Date(d * 1000)
  let YY = date.getFullYear() + '-'
  let MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  let DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
  let hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
  let mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes())
  let ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
  if (hasYmd) {
    return hh + mm
  } else {
    return hh + mm +':'+ ss
  }
}
/**
 * 获取月天
 * @param {} d 
 * @returns 
 */
export function getMonDay (d) {
  var date = new Date(d * 1000)
  var YY = date.getFullYear() + '-'
  var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
  var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
  var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
  var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
  return MM + DD
}
/**
 * 时间差
 * @param {*} sDate1
 * @param {*} eDate2
 */
export function dateDiff (sDate1, eDate2) {
  var diff = parseInt(eDate2 - sDate1)
  if (diff < 0) {
    return 0
  } else {
    const iDays = parseInt(diff / 60 / 60 / 24)
    return iDays + 1
  }
}
/**
 * 返回AddDayCount 天后的时间和星期
 * @param {} AddDayCount 
 * @returns 
 */
export function GetDateObj(AddDayCount) {
  let dd = new Date();
  dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期
  let y = dd.getFullYear();
  let m = dd.getMonth()+1;//获取当前月份的日期
  let d = dd.getDate();
  let day = dd.getDay();
  let weeks = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六");
  let week = weeks[day];
  if (m<10) {
    m='0'+m
  }
  if (d<10) {
    d='0'+d
  }
  let result = {
    id:parseInt(dd.getTime()/1000),
    week,
    date: m + "-" + d
  }
  return result
}
/**
 * 判断是否当日号
 */
export function isCurrDay(dt) {
  let dateTime = formatDate(dt, true)
  let date=formatDate(parseInt(new Date().getTime()/1000),true)
  return date.indexOf(dateTime)>-1
}
/**
 * 是否是微信浏览器
 */
export function isWeixin() {
  let ua = navigator.userAgent.toLowerCase();
  if(ua.match(/MicroMessenger/i)=="micromessenger") {  
    return true;  
  } else {  
    return false;  
  } 
}
/**
 * 是否存在token
 * @returns 
 */
export function hasToken() {
  const token=storage.get('token')
  return token?true:false

}